module.exports = __webpack_public_path__ + "static/media/fondo_produccion_discografica.289a6845.jpg";